/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IHealthkitOrStravaOrGarminOrGoogleFit {
  Healthkit = 'healthkit',
  Strava = 'strava',
  Garmin = 'garmin',
  GoogleFit = 'google-fit',
}
